/**
 * ============================================================================
 * RecurringDiscountInputs - DISCOUNT PERCENTAGE INPUT FIELDS
 * ============================================================================
 *
 * Extracted from 100+ line inline form section
 * Clean, reusable discount input component
 *
 * ============================================================================
 */

import React from 'react';

interface RecurringDiscountInputsProps {
  discount1Month: number | '';
  discount3Months: number | '';
  discount6Months: number | '';
  discount12Months: number | '';
  onChange: (field: string, value: number | '') => void;
  errors?: { [key: string]: string };
}

/**
 * Recurring discount input fields
 */
export function RecurringDiscountInputs({
  discount1Month,
  discount3Months,
  discount6Months,
  discount12Months,
  onChange,
  errors = {},
}: RecurringDiscountInputsProps) {
  const discounts = [
    { field: 'discount1Month', label: '1 Month', value: discount1Month },
    { field: 'discount3Months', label: '3 Months', value: discount3Months },
    { field: 'discount6Months', label: '6 Months', value: discount6Months },
    { field: 'discount12Months', label: '12 Months', value: discount12Months },
  ];

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <h5 className="text-sm font-semibold text-gray-900 mb-3">
        Bulk Booking Discounts (%)
      </h5>
      <p className="text-xs text-gray-600 mb-4">
        Offer discounts to incentivize longer commitments. Enter 0 for no discount.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {discounts.map(({ field, label, value }) => (
          <div key={field}>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              {label}
            </label>
            <div className="relative">
              <input
                type="number"
                min="0"
                max="100"
                step="0.5"
                value={value === '' ? '' : value}
                onChange={(e) => {
                  const val = e.target.value;
                  onChange(field, val === '' ? '' : parseFloat(val));
                }}
                className={`w-full border ${
                  errors[field] ? 'border-red-300' : 'border-gray-300'
                } rounded-md px-3 py-2 pr-8 text-sm ${
                  errors[field] ? 'focus:ring-red-500 focus:border-red-500' : ''
                }`}
                placeholder="0"
              />
              <span className="absolute right-3 top-2 text-gray-500 text-sm">%</span>
            </div>
            {errors[field] && (
              <p className="text-xs text-red-600 mt-1">{errors[field]}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
